export const MARKETPLACE_TOKEN = "marketplaceToken";